import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { Itens } from "../models/itens.model";

@Injectable()
export class ItensService extends BaseService<Itens> {

  constructor(public http: HttpClient) {
    super(http);
  }
  public getListCombos(id:number = null): Observable<any> {
    var url = id? '/list/'+id: '/list';
    return this.http.get<any>(this.baseUrl + url , { headers: this.headers });
  }
  public getFullById(id: number,agency_id:number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/' + id + '/' + agency_id, { headers: this.headers });
  }
  public getPathModule(): string {
    return '/reuniao/itens';
  }
}